export const SET_LOADING_ADDED_IMAGES = 'SET_LOADING_ADDED_IMAGES'
export const ADDED_IMAGES_SUCCESS = 'ADDED_IMAGES_SUCCESS'
export const ADDED_IMAGES_FAILED = 'ADDED_IMAGES_FAILED'
export const CLEAR_IMAGES = 'CLEAR_IMAGES'